import { render, staticRenderFns } from "./CreditNotePushForm.vue?vue&type=template&id=631a6d70&"
import script from "./CreditNotePushForm.vue?vue&type=script&lang=js&"
export * from "./CreditNotePushForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports